// Shared scale bracket configuration
export const scaleBrackets = [
  {
    label: 'Up to $10k sales per month',
    value: 10000,
    monthlyPrice: 9900,
    yearlyPrice: 8300,
    yearlyPriceFull: 99000,
  },
  {
    label: 'Up to $20k sales per month',
    value: 20000,
    monthlyPrice: 16900,
    yearlyPrice: 14100,
    yearlyPriceFull: 169000,
  },
  {
    label: 'Up to $30k sales per month',
    value: 30000,
    monthlyPrice: 23900,
    yearlyPrice: 19900,
    yearlyPriceFull: 239000,
  },
  {
    label: 'Up to $50k sales per month',
    value: 50000,
    monthlyPrice: 29900,
    yearlyPrice: 24900,
    yearlyPriceFull: 299000,
  },
  {
    label: 'Up to $75k sales per month',
    value: 75000,
    monthlyPrice: 39900,
    yearlyPrice: 33300,
    yearlyPriceFull: 399000,
  },
  {
    label: 'Up to $100k sales per month',
    value: 100000,
    monthlyPrice: 49900,
    yearlyPrice: 41600,
    yearlyPriceFull: 499000,
  },
  {
    label: 'Up to $150k sales per month',
    value: 150000,
    monthlyPrice: 69900,
    yearlyPrice: 58300,
    yearlyPriceFull: 699000,
  },
];

// Legacy bracket for existing $50k customers at old pricing (version 3)
export const legacyScaleBrackets = [
  {
    label: 'Up to $50k sales per month (legacy)',
    value: 50000,
    monthlyPrice: 39900,
    yearlyPrice: 33300,
    yearlyPriceFull: 399000,
    isLegacy: true,
  },
];

export default scaleBrackets;
